import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export interface JourneyBackBarProps {
  to: string;
  label: string;
  /** e.g. "Step 2 of 4" */
  step?: string;
}

/** Sticky-feeling top bar for Journey sub-pages (Week Hub, Reading, …). */
export const JourneyBackBar: React.FC<JourneyBackBarProps> = ({ to, label, step }) => (
  <div className="sp-backbar">
    <Link to={to} className="sp-backbar__link">
      <ArrowLeft size={15} />
      {label}
    </Link>
    {step && <span className="sp-backbar__step">{step}</span>}
  </div>
);
